import PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {Flex, Text} from '@chakra-ui/react'

import LogoSymbol from '~/react/components/Logo/LogoSymbol'

const RewardDetails = ({status, marmaladePointsEarnt}) => {
  const {t} = useTranslation('pointsOnPayments')
  if (status === 'failed') {
    return (
      <Text textStyle="body-small">
        {t('pointsOnPayments:pointsOnPayment.drawer.noMPointsEarned')}
      </Text>
    )
  }

  if (status !== 'successful') {
    return null
  }

  return (
    <Flex direction="column" gap="xxxs" align="end">
      <Flex align="center" justify="end" gap="xs">
        <LogoSymbol width="30px" height="30px" />
        <Text textStyle="body-small-medium">
          {t('pointsOnPayments:pointsOnPayment.drawer.mPointsEarned', {
            marmaladePointsEarnt,
          })}
        </Text>
      </Flex>
    </Flex>
  )
}

RewardDetails.propTypes = {
  status: PropTypes.string.isRequired,
  marmaladePointsEarnt: PropTypes.number.isRequired,
}

export default RewardDetails
